var React = require('react');

function Calendar (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M14.5 14.5H1.5V5.5H14.5V14.5ZM15 2H13V1C13 0.4 12.6 0 12 0H11C10.4 0 10 0.4 10 1V2H6V1C6 0.4 5.6 0 5 0H4C3.4 0 3 0.4 3 1V2H1C0.4 2 0 2.4 0 3V15C0 15.6 0.4 16 1 16H15C15.6 16 16 15.6 16 15V3C16 2.4 15.6 2 15 2Z","fill":"#181818"}));
}

Calendar.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Calendar;

Calendar.default = Calendar;
